export const POPULAR_CITIES = [
    {
        cityName: 'Chennai',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/7rPx06Qp7SrV0tJ2jO9lRq/570d83276c10822db860c233d5e0fe58/image.png'
    },
    {
        cityName: 'Coimbatore',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/3ho2ApLj0KlcgTY0Avxbvq/7e04cb13bc1385a93dfa4f189fd41919/image__1_.jpg'
    },
    {
        cityName: 'Madurai',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/1CYLlX6zchayL2dokBDo2j/5b89e4845fa371a0119c6ea27afc5eaf/image__2_.jpg'
    },
    {
        cityName: 'Salem',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/74ZO3Z09rDKvdTvhZxV5Be/97a67f5bf5817292fa8d35bce6104a5a/image__5_.jpg'
    },
    {
        cityName: 'Trichy',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/7MJgZy1gRQ3p2HjYb8uBOz/3a0f6a1ab49fcfcaba593418d77d2eaf/image__4_.jpg'
    },
    {
        cityName: 'Pondicherry',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/1C6nib3U53pY0H2GgTVNOV/f0ca51baf685d0b55cc6d3c4f413e426/image__3_.jpg'
    },
    {
        cityName: 'Vellore',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/7bBQwe5R4b1nA6JJYWzkKm/bac96b8f7253ab812a7670a7159eb07e/image__6_.jpg'
    },
    {
        cityName: 'Thanjavur',
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/uXxjoVGR1rzOVkHdS5BGr/f5daaec48a3b3af5a7bf53ed0b221137/image__7_.jpg?'
    }
]

export const POPULAR_ROUTES = [
    {
        origin: 'Chennai',
        destination: 'Vellore',
        distance: 188.6,
        image: 'https://www.crowdsourcedexplorer.com/wp-content/uploads/2021/04/Vellore-India-Tamil-Nadu-101263.jpg'
    },
    {
        origin: 'Chennai',
        destination: 'Coimbatore',
        distance: 505.5,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/iHGYg1mPmglkpSyoPv157/13fe19adbdc0e6f3f2c5a4c61740cc99/TmaUkl.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Salem',
        distance: 345,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/1m2o5NFAAXLLBwTskqmi8r/b34b58b53d2debc0e74eec5cc95af2ce/salem__1_.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Trichy',
        distance: 331.8,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/2ZJpWcZeKuezj1NQTPinvY/cfb6a5e82a51c4fbe128db2cdf259b3f/srirangam-temple-city-trichy.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Pondicherry',
        distance: 165.0,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/55uOjqGoGKyZwaYoHLeHM5/d5ca3c064c70c69c288c0859061fe7df/pondicherry-1061484_1280.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Bangalore',
        distance: 347.4,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/2lr4NASVtNHUE4rc58eG6m/bb8c831fbe079843d939c814ccb75817/pexels-photo-8529425.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Madurai',
        distance: 462.3,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/1CYLlX6zchayL2dokBDo2j/5b89e4845fa371a0119c6ea27afc5eaf/image__2_.jpg'
    },
    {
        origin: 'Chennai',
        destination: 'Tiruvannamalai',
        distance: 194,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/6HLzBPT4pmlv4KtHSBSbj/5d6a093458d08bbe5b54aa32d9c408d2/-70364_8196.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Tirupati',
        distance: 133,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/5h1Fbiu0QCTXOfojuV1Ofw/2d034605d510bfca2c5fa60616e06c70/wp6076037.jpeg'
    },
    {
        origin: 'Coimbatore',
        destination: 'Ooty',
        distance: 130,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/6keAizc7R4GxdKWLp9Qaiz/e55a9964d869e67fbe434a3664718990/53560wide.jpeg'
    },
    {
        origin: 'Tiruchirappalli',
        destination: 'Chennai',
        distance: 330.3,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/2ZJpWcZeKuezj1NQTPinvY/cfb6a5e82a51c4fbe128db2cdf259b3f/srirangam-temple-city-trichy.jpeg'
    },
    {
        origin: 'Chennai',
        destination: 'Dharmapuri',
        distance: 300.4,
        image: 'https://images.ctfassets.net/hkv6akvsgg6u/3nibmQ6hpact5qnGnkhzDh/cac1397801b7a01c686b2c654da49b0c/hogenakkal-mountain-rocks-132491760.jpeg'
    },

];


export const top_cities = [
    'Vellore',
    'chennai',
    'Coimbatore',
    'Madurai',
    'Trichy',
    'Pondicherry',
    'Salem',
    'Bangalore'
]

export const tamilnadu_districts = [
    'Ariyalur',
    'Chengalpattu',
    'Chennai',
    'Coimbatore',
    'Vellore',
    'Dharmapuri',
    'Dindigul',
    'Erode',
    'Kallakurichi',
    'Kanchipuram',
    'Kanyakumari',
    'Karur',
    'Krishnagiri',
    'Madurai',
    'Nagapattinam',
    'Namakkal',
    'Nilgiris',
    'Perambalur',
    'Pudukkottai',
    'Ramanathapuram',
    'Ranipet',
    'Salem',
    'Sivaganga',
    'Tenkasi',
    'Thanjavur',
    'Theni',
    'Thoothukudi',
    'Tiruchirappalli',
    'Tirunelveli',
    'Tirupathur',
    'Tiruppur',
    'Tiruvallur',
    'Tiruvannamalai',
    'Tiruvarur',
    'Vellore',
    'Viluppuram',
    'Virudhunagar',
    'Bangalore',
    'Pondicherry',
    'Tirupati',
 ];


 export const footer = [
"Madurai",
"Thanjavur",
"Coimbatore",
"Mahabalipuram",
"Kanyakumari",
"Kancheepuram",
"Rameswaram",
"Ooty",
"Coonoor",
"Kodaikanal",
"Trichy",
"Dharmapuri",
"Velankanni",
"Chettinad",
"Kumbakonam",
"Krishnagiri",
"Poompuhar",
"Puddukottai",
"Sivagangai",
"Tirunelveli",
"Thoothukudi",
"Tiruvarur",
"Vellore",
"Virudhunagar",
"Tiruvannamalai",
 ]

 export const allCities = [
    "Adirampattinam", "Aduthurai", "Alanganallur", "Alangayam", "Alangudi", "Alangudi", "Aliyar", "Ambasamudram", "Ambur", "Ammapettai", "Andipatti", "Arakkonam", "Arani", "Aranthangi", "Aravakurichi", "Arcot", "Ariyalur", "Arsikere", "Aruppukkottai", "Athani", "Attur", "Avalurpettai", "Avinashi", "Ayyampettai", "Badami", "Bagalkot", "Banavara", "Bangalore", "Bangalore Airport", "Bantwal", "Bargur", "Basavakalyan", "Batlagundu", "Belgaum", "Bellary", "Belur", "Bhadravathi", "Bhavani", "Bhuvanagiri", "Bidar", "Bodi", "Challakere", "Chamarajanagar", "Channagiri", "Chengalpet", "Chengam", "Chennai", "Chennai Airport", "Chetpet", "Cheyyar", "Chidambaram", "Chikkaballapur", "Chikmagalur", "Chinna Salem", "Chinnalapatti", "Chinnamanur", "Chitoor", "Cochin", "Coimbatore", "Coonoor", "Courtallam", "Vellore", "Cumbum", "Dandeli", "Davanagere", "Denkanikottai", "Devakottai", "Devarsugur", "Devikapuram", "Dhalavaipuram", "Dharapuram", "Dharasuram", "Dharmapuri", "Dharwad", "Dindugal", "Edappadi", "Elampillai", "Ernakulam", "Erode", "Gangaikonda Cholapuram", "Gangavathi", "Gingee", "Gobichettypalayam", "Gokak", "Gokarna", "Gudalur", "Gudiyatham", "Gulbarga", "Gumidipoondi", "Guntur", "Guruvayoor", "Hagaribommanahalli", "Hangal", "Harpanahalli", "Harur", "Hassan", "Haveri", "Hogenakkal", "Hosadurga", "Hosur", "Hubli", "Huliyar", "Humnabad", "Hunsur", "Hyderabad", "Jamkhandi", "Jayamkondam", "Jolarpettai", "Kadappa", "Kadayanallur", "Kalahasti", "Kalavai", "Kallakurichi", "Kalpakkam", "Kalugumalai", "Kamuthi", "Kanchipuram", "Kangayam", "Kaniyambadi", "Kannur", "Kanyakumari", "Karaikal", "Karaikudi", "Karkala", "Karur", "Karwar", "Katpadi", "Kattumannarkovil", "Kaveripakkam", "Kaveripattinam", "Kayalpattinam", "Kayathar", "Keelakarai", "Kil Pennathur", "Kodaikanal", "Kodiyakarai ", "Kodumudi", "Kolar", "Kollam", "Kollegal", "Komarapalayam ", "Koodankulam", "Koothanallur", "Koppal", "Kotagiri", "Kottampatty", "Kovilpatti", "Krishnagiri", "Kudachi", "Kudligi", "Kulasekharapatnam", "Kulithalai", "Kumbakonam", "Kumily", "Kumta", "Kurinjipadi ", "Kurnool", "Labbaikudikadu", "Lalgudi", "Madanapalli", "Madikeri", "Madukkur", "Madurai", "Madurantakam", "Mahabalipuram", "Mailam", "Manamadurai ", "Manamelkudi", "Manampathy", "Manaparai", "Mannarkudi", "Marakanam", "Marthandam", "Mayiladuthurai", "Melmalayanur", "Melmaruvathur", "Melur", "Mettupalayam", "Mettur", "Mimisal", "Mohanur", "Muddebihal", "Mudhol", "Mudigere", "Munnar", "Murdeshwar", "Musiri", "Muthupet", "Mysore", "Nagapattinam", "Nagercoil", "Naidupeta", "Namakkal", "Nanguneri", "Nannilam", "Natham", "Natrampalli", "Needamangalam", "Nellikkuppam", "Nellore", "Neyveli", "Nilakottai", "Oddanchatram", "Odugathur", "Omalur", "Ongole", "Ooty", "Palacode", "Palakad", "Palamaner", "Palani", "Palladam", "Pallikonda", "Pamba", "Panruti", "Papanasam", "Paramakudi", "Paramathi Velur", "Parangipettai", "Paranur", "Pattukottai", "Penagaram", "Pennadam", "Pennagaram", "Perambalur", "Peravurani", "Periyakulam", "Pernambut", "Perundurai", "Pichavaram", "Pillayarpatti", "Pochampalli ", "Pollachi", "Polur", "Pondicherry", "Ponnamaravathi", "Poompuhar", "Pudukkottai", "Puliyangudi", "Puttaparthi", "Puttur", "Puttur", "Raichur", "Rajapalayam", "Ramanathapuram", "Rameswaram", "Ranebennur", "Ranipet", "Rasipuram", "Rayakottai", "Sagar", "Salem", "Sankagiri", "Sankarankovil", "Sankarapuram ", "Sathyamangalam", "Sattur", "Sayalgudi", "Sembatti", "Sengottai", "Sethiyathope", "Shikkaripur", "Shivamogga", "Sholavandan ", "Sholinghur", "Shorapur", "Sirkazhi", "Sirsi", "Siruguppa", "Sivagangai", "Sivakasi", "Sricity", "Sriharikota", "Sriperumbudhur", "Srirangam", "Srivilliputhur", "Sullerpetai", "Swamimalai", "T.Kallupatti", "Tada", "Thalaivasal", "Thanjavur", "Tharangambadi", "Thekadi", "Thellar", "Theni", "Thenkasi", "Thirthahalli", "Thiruchendur", "Thirukadaiyur", "Thirukovillur", "Thirumangalam", "Thirumayam", "Thirunageswaram", "Thiruppanandal ", "Thiruthuraipoondi", "Thiruvadanai", "Thiruvaiyaru", "Thiruvallur", "Thiruvannamalai", "Thiruvarur", "Thiruvidaimaruthur", "Thondi", "Thottiyam", "Thrissur", " Kerala", "Thuckalay ", "Thuraiyur", "Thuvarankuruchi", "Timiri", "Tindivanam", "Tiruchengode", "Tirumala", "Tirupati", "Tirunelveli", "Tirupati", "Tirupattur ", "Tiruppathur", "Tiruppur", "Tiruttani", "Tittakudi", "Toludur ", "Trichur", "Trichy", "Trivandrum", "Tuticorin", "Udumalapettai", "Ulundurpettai", "Usilampatti", "Uthangarai", "Uthiramerur", "Vadalur", "Vaitheeswarankoil ", "Valliyur", "Valparai", "Vandavasi", "Vaniyampadi", "Vazhapadi", "Vedaranyam", "Vedasandur", "Velankanni", "Vellakoil", "Vellore", "Venkatagiri", "Vettavalam", "Vijayapura", "Vijayawada", "Vikravandi", "Villupuram", "Virajpet", "Viralimalai", "Virudachalam", "Virudhunagar", "Vishakapattinam", "Walajapet", "Walayar", "Wayanad", "Yadgir", "Yelagiri", "Yercaud"
]
